import { FileIcon, CodeIcon, FileJsonIcon, ImageIcon, FileTextIcon, FileArchiveIcon } from 'lucide-react';

// กำหนด type สำหรับ file config
type FileConfig = {
  icon: typeof FileIcon;
  color: string;
  extensions: string[];
}

// config สำหรับไฟล์แต่ละประเภท
export const FILE_CONFIGS: FileConfig[] = [
  {
    icon: CodeIcon,
    color: 'text-blue-500',
    extensions: ['.py', '.js', '.ts', '.jsx', '.tsx', '.html', '.css', '.scss', '.php', '.java', '.cpp', '.c', '.go']
  },
  {
    icon: FileJsonIcon,
    color: 'text-yellow-400',
    extensions: ['.json', '.yaml', '.yml', '.xml']
  },
  {
    icon: ImageIcon,
    color: 'text-pink-500',
    extensions: ['.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp']
  },
  {
    icon: FileTextIcon,
    color: 'text-gray-500',
    extensions: ['.txt', '.md', '.csv', '.log']
  },
  {
    icon: FileArchiveIcon,
    color: 'text-purple-500',
    extensions: ['.zip', '.rar', '.7z', '.tar', '.gz']
  }
];